module.exports = __webpack_public_path__ + "img/orange_012.a7f747fc.png";